<template>
  <div data-qa-id="blur-promotions" class="fou-promotion">
    <div
      v-for="promotion in PROMOTIONS"
      :key="promotion.promoTitle"
      data-qa-id="promotion-list"
      class="fou-promotion__list"
    >
      <span data-qa-id="promotion-title" class="fou-promotion__list__name is-blur is-blur--less">{{ promotion.promoTitle }}</span>
      <div data-qa-id="individual-promo" class="fou-promotion__list__desc is-blur is-blur--less">
        <span data-qa-id="title"> {{ promotion.expire }} </span>
        <link-arrow data-qa-id="icon" class="promotion-arrow" />
      </div>
    </div>
    <div data-qa-id="footer" class="footer-section">
      <button data-qa-id="create-promotion-navigation" class="promotion-btn--primary btn--disabled" disabled>
        <percentage-star class="percentage-star" />{{ $t('pages.dashboard.components.promotion.new_promotion') }}
      </button>
      <button data-qa-id="all-promotion-navigation" class="promotion-btn--secondary btn--disabled" disabled>
        {{ $t('pages.dashboard.components.promotion.all_promotion') }}
        <link-arrow class="ml-11" fill-color="#C3CAD4" />
      </button>
    </div>
  </div>
</template>

<script src="./script" />
